import { Typography } from "@mui/material";

export default function PopperList({ items }) {
  return (
    <div className="z-50 py-4 pl-2 pr-4 flex flex-col gap-1 rounded-lg border-b bg-slate-50 shadow-md">
      {items.map((item, key) => {
        if (item.hidden) return null;
        const isDisabled = Boolean(item.disabled);
        return (
          <div
            key={key}
            onClick={isDisabled ? undefined : item.onClick}
            aria-disabled={isDisabled}
            className={`z-50 py-1 pl-2 pr-6 rounded transition-colors ${
              isDisabled
                ? "opacity-50 cursor-not-allowed text-gray-400"
                : "cursor-pointer hover:bg-slate-200"
            }`}
            style={isDisabled ? { pointerEvents: "none" } : {}}
          >
            <Typography fontSize={14}>{item.label}</Typography>
          </div>
        );
      })}
    </div>
  );
}
